import { Component, OnInit } from '@angular/core';
import {TelecontactService} from "./telecontact.service";
import {ExportService} from "./export.service";
import {Chart} from "chart.js";
import 'chartjs-plugin-colorschemes';
import {DialogComponent} from "../helpers/dialog/dialog.component";
import {NbDialogService, NbSidebarService} from "@nebular/theme";


@Component({
  selector: 'app-telecontact',
  templateUrl: './telecontact.component.html',
  styleUrls: ['./telecontact.component.scss']
})
export class TelecontactComponent implements OnInit {

  public isLoading = false;

  public render = {'filters': {'region': [
        "benimellal_khenifra",
        "casablanca_settat",
        "dakhla_oueded_dahab",
        "daraa_tafilalet",
        "fes_meknes",
        "guelmim_ouednoun",
        "laayoune_sakiaelhamra",
        "loriental",
        "marrakech_safi",
        "rabat_sale_kenitra",
        "souss_massa",
        "tanger_tetouan_alhoceima"
      ]}};
  public data = [];


  constructor(private telecontactService: TelecontactService,
              private exportService: ExportService,
              private dialogService: NbDialogService,
              private sidebarService: NbSidebarService) {}



  ngOnInit() {
    Chart.defaults.global.plugins.colorschemes.scheme = 'office.Waveform6';

    this.isLoading = true;
    this.render['regions'] = 'await';
    this.render['cities'] ='await';
    this.render['hr'] = 'await';
    this.render['date'] = 'await';

    this.render['cols'] = {'region': [], 'city': []};

    this.telecontactService.getCol('region').subscribe( d =>{
      this.render['cols']['region'] = d;
      console.log(d);
    });

    this.telecontactService.getCol('city').subscribe( d =>{
      this.render['cols']['city'] = d
    });

    this.refresh(this.render['filters']);
  }

  convertRegion(from, dir=1){
    let cc = {
      "benimellal_khenifra": "Benimellal, khenifra",
      "casablanca_settat":"Casablanca, Settat",
      "dakhla_oueded_dahab":"Dakhla, Oued eddahab",
      "daraa_tafilalet":"Daraa, Tafilalet",
      "fes_meknes":"Fez, Meknes",
      "guelmim_ouednoun":"Guelmim, Ouednoun",
      "laayoune_sakiaelhamra":"Laayoune, Sakia El Hamra",
      "loriental":"Eastern",
      "marrakech_safi":"Marrakech, Safi",
      "rabat_sale_kenitra":"Rabat, Salé, Kenitra",
      "souss_massa":"Souss, Massa",
      "tanger_tetouan_alhoceima":"Tanger, Tetouan, Al Hoceima"
    };

    let dd = {};
    for ( let k of Object.keys(cc) ){
      dd[cc[k]] = k;
    }

    if ( dir !== 1){
      return dd[from];
    }

    return cc[from];
  }


  public refresh(filters){

    this.render['date']= 'await';
    this.telecontactService.numberByDate(filters).subscribe(d => {
      this.render['date'] = d;
    });

    this.render['regions'] = 'await';
    this.telecontactService.numberByRegions(filters).subscribe( d => {
      d['labels'] = d['labels'].map(c => this.convertRegion(c));
      this.render['regions'] = d;
    });

    this.render['cities'] = 'await';
    this.telecontactService.numberByCities(filters).subscribe( d => {
      d['labels'] = d['labels'].map(c => this.capitaliz(c));
      this.render['cities'] = d;
      console.log(d);
    });

    this.render['hr'] = 'await';
    this.telecontactService.numberByHr(filters).subscribe( d => {
      this.render['hr'] = d;
    });
  }

  capitaliz(string: string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }




  refAll() {
    this.refresh( this.render['filters']);
  }

  checked(ev, val, col) {
    if ( ev ) {

      if ( ! this.render['filters'][col].includes(val) ) {
        this.render['filters'][col].push(val);
        this.refAll();
      }

    } else {
      this.rmFilter(col, val);
      this.refAll();
    }


  }



  public rmFilter(col, e){
    this.render['filters'][col] = this.render['filters'][col].filter( d => d !== e);
    if ( this.render['filters'][col].length === 0 ){
      delete this.render['filters'][col];
    }
    this.refAll();
  }

  exportAsXLSX():void {
    this.exportService.exportAsExcelFile(this.data, 'sample');
  }

  openInfo(){
    this.dialogService.open(DialogComponent, {context: {
        title: 'Dialisis centers distribution in Morocco',
        desc: 'Let\'s assume a person wants to build a Dialysis Center in Morocco. Let alone the fact that it\'s an' +
          '              expensive project, it\'s really hard to choose a location where this project is going to be profitable the' +
          '              most. To respond to this problem, we collect detailed data from trusted sources about all Dialysis centers' +
          '              in Morocco, and provide a dashboard for our users to explore this data and make the best decision.',
      }});
  }

  selectAll( field ){
    this.render['filters'][field] = this.render['cols'][field];
    this.refAll();
  }

  unselectAll( field ){
    this.render['filters'][field] = [];
    this.refAll();
  }

  toggle() {
    this.sidebarService.toggle(false, 'left');
  }

}
